<template>
  <div class="form__group">
    <label :for="name" v-if="label">{{ label }}: <span class="required" v-if="required">*</span></label>
    <input type="file" :id="name" :name="name" @change="changeFileHandle" :required="required" class="form-control" :class="{'is-danger': fileError || hasError}">
    <span class="help is-danger" v-if="fileError || hasError">{{ errorMessage }}</span>
  </div>
</template>

<script>
import service from '@/services/index'
import { mapActions } from 'vuex'

const resource = service.resource('races/upload-image')
const resourceActionImage = service.resource('races/upload-action-image')

export default {
  name: 'uploadField',
  props: {
    label: {
      required: false,
      type: String
    },
    value: {
      required: true
    },
    name: {
      required: true,
      type: String
    },
    errorMessage: {
      required: false,
      type: String
    },
    hasError: {
      required: false
    },
    required: {
      type: Boolean
    }
  },
  data: () => ({
    input: '',
    fileError:false
  }),
  methods: {
    changeFileHandle (e) {
      const originalFile = e.target.files[0]

      const file = new FormData()
      file.append('file', originalFile)
      const size = originalFile.size/1024
      console.log("size---",size)
      if(size > 200){
        this.fileError=true
        this.$emit('input', null)
      }else { 
        console.log("label---",this.label)
        this.fileError=false
        if(this.label == 'Action Image'){
          this.addTaskToQueue('saveActionImage')
          resourceActionImage.save(file)
            .then(({ body }) => {
            this.$emit('input', body.url)
            this.removeTaskFromQueue('saveActionImage')
          })
        }else{
          this.addTaskToQueue('saveRacePhoto')
          resource.save(file)
            .then(({ body }) => {
            this.$emit('input', body.url)
            this.removeTaskFromQueue('saveRacePhoto')
          })

        }
       
      } 
    },
    ...mapActions({
      addTaskToQueue: 'LoadingQueue/addTaskToQueue',
      removeTaskFromQueue: 'LoadingQueue/removeTaskFromQueue'
    })
  }
}
</script>



// WEBPACK FOOTER //
// RacePhoto.vue?492e60ef